import React, { ReactElement } from 'react';
import HBMenuItem from './HBMenuItemOld';
import type { TMenuItem } from './HBMenuItemOld.types';
import HBPopover from '../HBPopover/HBPopover';
import { TOpenTrigger, IOnOpenChange } from '../HBPopover/HBPopover.types';
import { Placement } from '@popperjs/core';

export interface IMenuProps {
    target: ReactElement | Function;
    menuItems: TMenuItem[];
    openTrigger?: TOpenTrigger;
    placement?: Placement;
    offsetX?: number;
    offsetY?: number;
    className?: string;
    withArrow?: boolean;
    targetContainerStyle?: React.CSSProperties;
    customStyle?: React.CSSProperties;
    shouldSupportOverflowHidden?: boolean;
    stopPropagationOnTargetClick?: boolean;
    onOpenChange?: ({ isOpen }: IOnOpenChange) => void;
    forceClose?: boolean;
}

const HBMenuOld = ({
    target,
    menuItems,
    placement = 'bottom',
    openTrigger = 'click',
    className,
    withArrow = true,
    targetContainerStyle,
    shouldSupportOverflowHidden = false,
    stopPropagationOnTargetClick = false,
    customStyle,
    offsetX,
    offsetY,
    onOpenChange,
    forceClose
}: IMenuProps) => {
    return (
        <HBPopover
            withArrow={withArrow}
            target={target}
            className={className}
            placement={placement}
            offsetX={offsetX}
            offsetY={offsetY}
            theme="menu"
            openTrigger={openTrigger}
            shouldSupportClickOutside
            shouldSupportOverflowHidden={shouldSupportOverflowHidden}
            stopPropagationOnTargetClick={stopPropagationOnTargetClick}
            customStyle={{
                minWidth: '200px',
                ...customStyle
            }}
            onOpenChange={onOpenChange}
            // @ts-ignore
            targetContainerStyle={{ display: 'flex', ...targetContainerStyle }}
            testId="menu-old"
            forceClose={forceClose}
        >
            {setIsOpen =>
                menuItems?.map((item, index) => (
                    <HBMenuItem
                        key={index.toString()}
                        item={item}
                        closeMenu={() => setIsOpen({ newIsOpen: false })}
                    />
                ))
            }
        </HBPopover>
    );
};

export default HBMenuOld;
